module.exports = __webpack_public_path__ + "img/image.c8b5d9a4.png";